import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import BigPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/BigPicklistControl';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import moment from 'moment';
import { defaultFormat } from 'Consts/DateFormats';

const hiddenFieldNames = [];

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride('fundingType', {
    _component: () => BigPicklistControl,
  })
  .nameOverride(name => hiddenFieldNames.includes(name), {
    hidden: true,
  })
  .nameOverride('transferDate', {
    _component: () => DateField,
    _customProps: {
      openTo: 'year',
      views: ['year', 'month', 'date'],
    },
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment.utc(v).format(defaultFormat);
    },
  });
